/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo = { readonly __typename: 'BankInfo', readonly accountNumberLastFour: string | null };

export type GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo = { readonly __typename: 'CreditApplicationFinanceInfo', readonly desiredCredit: any | null, readonly bankInfo: GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo | null };

export type GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument = { readonly __typename: 'CreditApplicationDocument', readonly documentUuid: string, readonly documentType: _Types.CreditDocument, readonly isReRequested: boolean, readonly statusMessage: string | null };

export type GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly authorizedSigner: GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly beneficialOwners: ReadonlyArray<GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson | null> | null, readonly financeInfo: GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo | null, readonly requiredDocs: ReadonlyArray<GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument> | null };

export type GetRequiredDocumentsMobileUpload_Query = { readonly __typename: 'Query', readonly creditApplication: GetRequiredDocumentsMobileUpload_creditApplication_CreditApplication | null };


export type GetRequiredDocumentsMobileUploadVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetRequiredDocumentsMobileUpload = GetRequiredDocumentsMobileUpload_Query;


export const GetRequiredDocumentsMobileUploadDocument = gql`
    query GetRequiredDocumentsMobileUpload($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    authorizedSigner {
      id
      firstName
      lastName
    }
    beneficialOwners {
      id
      firstName
      lastName
    }
    financeInfo {
      desiredCredit
      bankInfo {
        accountNumberLastFour
      }
    }
    requiredDocs {
      documentUuid
      documentType
      isReRequested
      statusMessage
    }
  }
}
    `;

/**
 * __useGetRequiredDocumentsMobileUpload__
 *
 * To run a query within a React component, call `useGetRequiredDocumentsMobileUpload` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredDocumentsMobileUpload` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredDocumentsMobileUpload({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetRequiredDocumentsMobileUpload(baseOptions: Apollo.QueryHookOptions<GetRequiredDocumentsMobileUpload, GetRequiredDocumentsMobileUploadVariables> & ({ variables: GetRequiredDocumentsMobileUploadVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredDocumentsMobileUpload, GetRequiredDocumentsMobileUploadVariables>(GetRequiredDocumentsMobileUploadDocument, options);
      }
export function useGetRequiredDocumentsMobileUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredDocumentsMobileUpload, GetRequiredDocumentsMobileUploadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredDocumentsMobileUpload, GetRequiredDocumentsMobileUploadVariables>(GetRequiredDocumentsMobileUploadDocument, options);
        }
export function useGetRequiredDocumentsMobileUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredDocumentsMobileUpload, GetRequiredDocumentsMobileUploadVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredDocumentsMobileUpload, GetRequiredDocumentsMobileUploadVariables>(GetRequiredDocumentsMobileUploadDocument, options);
        }
export type GetRequiredDocumentsMobileUploadHookResult = ReturnType<typeof useGetRequiredDocumentsMobileUpload>;
export type GetRequiredDocumentsMobileUploadLazyQueryHookResult = ReturnType<typeof useGetRequiredDocumentsMobileUploadLazyQuery>;
export type GetRequiredDocumentsMobileUploadSuspenseQueryHookResult = ReturnType<typeof useGetRequiredDocumentsMobileUploadSuspenseQuery>;
export type GetRequiredDocumentsMobileUploadQueryResult = Apollo.QueryResult<GetRequiredDocumentsMobileUpload, GetRequiredDocumentsMobileUploadVariables>;